module.exports = __webpack_public_path__ + "media/images/icons/logout-0739770c45b6d2b22179ded3f71b49ea.svg";